// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "\n.videopage video[data-v-61e37eac] {\n  width: 100%;\n  height: auto;\n}\n", "",{"version":3,"sources":["C:/Users/lenovo/Desktop/新建文件夹 (9)/fission_video_front/src/view/video.vue","video.vue"],"names":[],"mappings":";AAOA;EAEQ,WAAA;EACA,YAAA;ACNR","file":"video.vue","sourcesContent":["\n\n\n\n\n\n\n.videopage {\n    video {\n        width: 100%;\n        height: auto;\n    }\n}\n",".videopage video {\n  width: 100%;\n  height: auto;\n}\n"]}]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61e37eac","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true,"javascriptEnabled":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/video.vue
// module id = Ma8n
// module chunks = 1